import { colors } from '../../colors';
var pagination = {
  activeColor: colors.clearBlue,
  defaultColor: colors.darkNight
};
export default pagination;